import { SchemaScheduleListAppointments } from './api';
import { ProvidersExceptionsForMultipleProvidersOfMultiLocations, SchemaGetOnlineSchedulingLink } from './types';

export const queryKeys = {
  base: ['schedule'] as const,
  providerExceptions: (req: ProvidersExceptionsForMultipleProvidersOfMultiLocations['input']) => [
    ...queryKeys.base,
    'providerExceptions',
    req,
  ],
  appointments: (req: SchemaScheduleListAppointments['input']) => [...queryKeys.base, 'appointments', req],
  appointmentsInfinite: (req: SchemaScheduleListAppointments['input']) => [
    ...queryKeys.base,
    'appointmentsInfinite',
    req,
  ],
  onlineScheduleLink: (req: SchemaGetOnlineSchedulingLink['input']) => [
    ...queryKeys.base,
    'online-scheduling-link',
    req,
  ],
};
